import { createAsyncThunk } from '@reduxjs/toolkit';
import type { GetServerSidePropsContext } from 'next';

import doFetch from 'utils/doFetch';

const getAllArticlesThunk = createAsyncThunk(
  'articles/getAllArticles',
  async (context: GetServerSidePropsContext) => {
    try {
      const apiPointName = 'getAllArticles';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        context,
        body: null,
      });
    } catch (err) {
      const errorToReject = err instanceof Error ? err : new Error(typeof err === 'object' ? JSON.stringify(err, null, 2) : String(err));
      console.error({ errorToReject });

      return Promise.reject(errorToReject);
    }
  },
);

export default getAllArticlesThunk;
